// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\UserResponse

import { UserRole } from './enums.gen';
import { DateTimefromISO } from '#lib/helper/date.js';
import type { DateTime } from 'luxon';

export type UserApiResponse = {
	id: string;
	email: string;
	firstName: string;
	lastName: string;
	phone: string;
	role: UserRole;
	locale: string;
	defaultBusinessId: string;
	releaseNotesReadAt: string;
	doNotDisturbUntil: string | null;
	cguAcceptedAt: string | null;
	termsAcceptedAt: string | null;
	privacyAcceptedAt: string | null;
};

export type User = {
	id: string;
	email: string;
	firstName: string;
	lastName: string;
	phone: string;
	role: UserRole;
	locale: string;
	defaultBusinessId: string;
	releaseNotesReadAt: DateTime;
	doNotDisturbUntil: DateTime | null;
	cguAcceptedAt: DateTime | null;
	termsAcceptedAt: DateTime | null;
	privacyAcceptedAt: DateTime | null;
};

export function hydrateUser(data: UserApiResponse): User {
	return {
		...data,
		releaseNotesReadAt: DateTimefromISO(data.releaseNotesReadAt)!,
		doNotDisturbUntil: DateTimefromISO(data.doNotDisturbUntil),
		cguAcceptedAt: DateTimefromISO(data.cguAcceptedAt),
		termsAcceptedAt: DateTimefromISO(data.termsAcceptedAt),
		privacyAcceptedAt: DateTimefromISO(data.privacyAcceptedAt),
	};
}